export default __webpack_public_path__ + "static/media/Paspor salah.5c3a692e.jpg";